interface QRDisplayProps {
  base64Image?: string;
  validThru?: string; // ISO date string from TransactionValidThru
  instructions?: string;
  configuration?: any;
}

export function QRDisplay({ base64Image, validThru, instructions, configuration }: QRDisplayProps) {
  // Option to hide via configuration if merchant explicitly disables QR visualization
  const isEnabled = configuration?.AdditionalConfig?.EnableQRDisplay !== false;
  const safeDataImage = /^data:image\/(?:png|jpe?g|webp|gif);base64,/i;
  const imageSource = base64Image && safeDataImage.test(base64Image)
    ? base64Image
    : base64Image
      && !base64Image.trim().toLowerCase().startsWith('data:')
      ? `data:image/png;base64,${base64Image}`
      : '';

  if (!isEnabled) return null;

  return (
    <div className="flex flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 rounded-xl bg-gray-50 mt-6">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-gray-800">
          Escanea para pagar
        </h3>
        {instructions && (
          <p className="text-sm text-gray-500 mt-1">{instructions}</p>
        )}
      </div>

      {imageSource ? (
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
          <img
            src={imageSource}
            alt="Código QR de Pago"
            className="w-48 h-48 object-contain"
          />
        </div>
      ) : (
        <div className="w-48 h-48 bg-white p-4 rounded-lg shadow-sm border border-gray-100 flex items-center justify-center text-center text-sm text-gray-500">
          Preparando las instrucciones de pago…
        </div>
      )}

      {validThru && (
        <div className="mt-4 text-xs font-medium text-amber-600 bg-amber-50 px-3 py-1.5 rounded-full border border-amber-200">
          Expira: {new Date(validThru).toLocaleTimeString()}
        </div>
      )}
    </div>
  );
}
